import { dictionaryApi } from './dictionaryClient';
import { SAMASTA_TYPE } from '../constants/samastaEnums';

export type SamastaCompoundType = (typeof SAMASTA_TYPE)[number];

export type SamastaCompound = {
  id: number;
  type: string;
  first_wordId: number;
  second_wordId: number;
  subantaId: number;
};

export type CreateSamastaCompoundBody = {
  type: string;
  first_wordId: number;
  second_wordId: number;
  subantaId: number;
};

function normalizeList(data: unknown): SamastaCompound[] {
  if (Array.isArray(data)) return data as SamastaCompound[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: SamastaCompound[] }).data;
  }
  return [];
}

export async function listSamastaCompounds(): Promise<SamastaCompound[]> {
  const res = await dictionaryApi.get<unknown>('/samasta');
  return normalizeList(res.data);
}

export async function getSamastaCompound(id: number): Promise<SamastaCompound> {
  const res = await dictionaryApi.get<SamastaCompound>(`/samasta/${id}`);
  return res.data;
}

export async function createSamastaCompound(
  body: CreateSamastaCompoundBody
): Promise<SamastaCompound> {
  const res = await dictionaryApi.post<SamastaCompound>('/samasta', body);
  return res.data;
}

export async function updateSamastaCompound(
  id: number,
  body: Partial<Pick<SamastaCompound, 'type' | 'first_wordId' | 'second_wordId' | 'subantaId'>>
): Promise<SamastaCompound> {
  const res = await dictionaryApi.patch<SamastaCompound>(`/samasta/${id}`, body);
  return res.data;
}

export async function deleteSamastaCompound(id: number): Promise<void> {
  await dictionaryApi.delete(`/samasta/${id}`);
}
